import React from 'react';
import Logo from './assets/logolight';
import { Link } from 'react-router-dom';
import { withMedia } from 'react-media-query-hoc';
import './Footer.css';

export default withMedia(function (props) {
  return (
    <footer>
      <div className={props.container || "container"}>
        <Link className="logo" to="/">
          <Logo/>
        </Link>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="/privacy-policy"
        >
          Privacy {props.media.mobile ? '' : 'Policy'}
        </a>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to="/terms-and-conditions"
        >
          Terms {props.media.mobile ? '' : '& Conditions'}
        </Link>
      </div>
    </footer>
  );
});



// WEBPACK FOOTER //
// ./src/Components/Footer.js